<card-info-detail-v2 class="card-content" [showButton]="true" (viewMoreLessEvent)="onClickViewMoreLess($event)">
  <h2 title i18n="@@descripcion">Descripción</h2>

  <seo-detail static-info *ngIf="isLanding" [hotelStatic]="hotelStatic"></seo-detail>

  <div expanded-info class="text">
    <ng-container *ngFor="let parrafo of arrayDescription">
      <ng-container *ngIf="parrafo !== ''">
        <ng-container *ngIf="!validRegExp(parrafo); else withUrl">

          <div class="text-description" [innerHTML]="parrafo"></div>
        </ng-container>
      </ng-container>
    </ng-container>

    <div class="additional-info" *ngIf="additionalInfos">
      <div *ngFor="let info of additionalInfos">
        <h3 class="title" (click)="panel.expanded() ? panel.close() : panel.open()">
          <span>{{ info.type }}</span>
          <mb-icon icon="arrow-down" [verticalFlip]="panel.expanded()"></mb-icon>
        </h3>
        <mb-expandable-panel #panel>
          <div class="content">{{ info.values[0] }}</div>
        </mb-expandable-panel>
      </div>
    </div>
  </div>
</card-info-detail-v2>

<ng-template #withUrl>
  <ng-container *ngFor="let element of textResult">
    <ng-container *ngIf="validRegExp(element)">
      <a [href]="element">{{ element }}</a>
    </ng-container>
    <ng-container *ngIf="!validRegExp(element)">
      {{ element }}
    </ng-container>
  </ng-container>
</ng-template>